export enum LEARNING {
    /**
     * @value LEARNING
     */
    LEARNING = 'ADMIN.NAV.LEARNING',
    /**
     * @value learning analytics page
     */
    LEARNING_ANALYTICS_PAGE_TITLE = 'LEARNING.ANALYTICS_PAGE_TITLE',
    /**
     * @value learning categories page
     */
    LEARNING_CATEGORIES_PAGE_TITLE = 'LEARNING.CATEGORIES_PAGE_TITLE',
    /**
     * @value Certificates
     */
    LEARNING_CERTIFICATES = 'LEARNING.CERTIFICATES',
    /**
     * @value learning certificates page
     */
    LEARNING_CERTIFICATES_PAGE_TITLE = 'LEARNING.CERTIFICATES_PAGE_TITLE',
    /**
     * @value Learners
     */
    LEARNING_LEARNERS = 'LEARNING.LEARNERS',
    /**
     * @value learning learners page
     */
    LEARNING_LEARNERS_PAGE_TITLE = 'LEARNING.LEARNERS_PAGE_TITLE',
    /**
     * @value learning managers page
     */
    LEARNING_MANAGERS_PAGE_TITLE = 'LEARNING.MANAGERS_PAGE_TITLE',
    /**
     * @value learning training courses page
     */
    LEARNING_TRAINING_COURSES_PAGE_TITLE = 'LEARNING.TRAINING_COURSES_PAGE_TITLE',
    /**
     * @value Mission Center
     */
    MISSION_CENTER = 'LEARNING.MISSION_CENTER',
}
